module.exports = __webpack_public_path__ + "img/Gemeindezeltlager(3).79a57ce5.jpg";